<template>
    <section class="header-subtotal">
        <h2 class="header-subtotal-cart">Cart</h2>
        <sub-total
            :action="action"
            :button-class="buttonClass"
        >
            <slot>
                Checkout
            </slot>
        </sub-total>
    </section>
</template>

<script>
import SubTotal from "../accessories-store/sub-total-row/sub-total";

export default {
    name: "HeaderSubtotal",
    components: {
        SubTotal
    },
    props: {
        action: {
            type: Function,
            required: true
        },
        buttonClass: {
            type: [String, Object],
            default: ""
        }
    }
}
</script>

<style lang="scss">
    .header-subtotal {
        .sub-total-details {
              @media (min-width: 320px) and (max-width: 580px) {
                margin-top: 0;
            }
        }
    }
</style>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.header-subtotal {
    margin: 52px 0 52px;
    display: flex;
    justify-content: space-between;

    @media (min-width: 320px) and (max-width: 580px) {
        margin: 30px 0 43px;
        flex-direction: column;
    }

    &-cart {
        color: $black;
        font-size: 48px;

        @media (min-width: 320px) and (max-width: 580px) {
            margin-bottom: 20px;
            font-size: 24px;
        }
    }
}
</style>
